import React from 'react';

import cn from 'classnames';

import { snakeToCamel } from '@shared/helpers';
import { Dropdown, Flex, Icon, Skeleton } from '@shared/ui';
import { Status } from '@widgets/EstimateInformation/model/types/types';
import { InfoItem } from '@widgets/EstimateInformation/ui/InfoItem';
import { WarningPopup } from '@widgets/EstimateInformation/ui/modals/WarningPopup';

import cls from './EstimateStatus.module.css';
import { useEstimateStatus } from '../../lib/hooks/useEstimateStatus';

export const EstimateStatus = () => {
    const {
        status,
        statusMapping,
        btnRef,
        onShowDropdown,
        onHideDropdown,
        onChangeStatus,
        isShowDropdown,
        data,
        t,
        isShowPopup,
        onHidePopup,
        onSetDraft,
        isPending,
    } = useEstimateStatus();

    return (
        <>
            <WarningPopup
                isOpen={isShowPopup === Status.IN_EXPLOITATIONS}
                onHidePopup={onHidePopup}
                btnActionCb={onSetDraft}
            />
            <InfoItem label={t('EstimateStatus.InfoItem.label')}>
                {isPending ? (
                    <Skeleton width={86} height={26} border="8px" />
                ) : (
                    <Flex
                        className={cn(cls.EstimateStatus)}
                        onClick={data?.status?.canSwitchStatus ? onShowDropdown : undefined}
                        ref={btnRef}
                    >
                        <Flex
                            gap={8}
                            justify="center"
                            align="center"
                            className={cn(
                                cls.EstimateStatusContent,
                                cls[status],
                                data?.status.canSwitchStatus && cls.EstimateStatusContentHover
                            )}
                        >
                            {statusMapping[status]}
                            {data?.status?.canSwitchStatus && <Icon iconName="selectArrowThin" />}
                        </Flex>

                        <Dropdown
                            buttonRef={btnRef}
                            className={cls.dropdown}
                            isOpen={isShowDropdown}
                            onClose={onHideDropdown}
                        >
                            <Dropdown.List>
                                {data?.status?.availableStatuses.map((item) => (
                                    <Dropdown.ListItem
                                        key={item}
                                        className={cls.listItem}
                                        onClick={onChangeStatus(snakeToCamel(item) as Status)}
                                    >
                                        <div className={cn(cls.round, cls[snakeToCamel(item)])} />
                                        {statusMapping[snakeToCamel(item) as Status]}
                                    </Dropdown.ListItem>
                                ))}
                            </Dropdown.List>
                        </Dropdown>
                    </Flex>
                )}
            </InfoItem>
        </>
    );
};
